import React, { useState, useEffect } from 'react';
import TipTapOpcionEditor from '../../../../../../components/atoms/TipTapOpcionEditor';
import './OpcionItem.css';

const OpcionItem = ({ 
  opcion, 
  index, 
  onUpdate,
  onEliminar,
  canDelete,
  lockAsCorrect = false,
  lockPuntaje = false,
  autoDesactivarConPuntajeCero = false
}) => {
  const letra = String.fromCharCode(65 + index);
  const [puntajeInput, setPuntajeInput] = useState(String(opcion.puntaje ?? 0));
  const esCorrectaVisible = lockAsCorrect ? true : opcion.esCorrecta;

  // Sincronizar si el puntaje cambia desde el padre (ej: carga inicial)
  useEffect(() => {
    setPuntajeInput(String(opcion.puntaje ?? 0));
  }, [opcion.puntaje]);
  
  return (
    <div className={`opcion-item-card mb-3 ${esCorrectaVisible ? 'opcion-correcta' : ''}`}>
      <div className="opcion-item-body">
        <div className="row align-items-center">
          <div className="col-auto">
            <button
              type="button"
              className={`btn-letra ${esCorrectaVisible ? 'btn-letra-correcta' : 'btn-letra-normal'}`}
              onClick={() => !lockAsCorrect && onUpdate({ esCorrecta: !opcion.esCorrecta })}
              title={lockAsCorrect ? 'En Salamanca todas las opciones son correctas' : opcion.esCorrecta ? 'Marcar como incorrecta' : 'Marcar como correcta'}
              disabled={lockAsCorrect}
            >
              {letra}
            </button>
          </div>
          
          <div className="col">
            <TipTapOpcionEditor
              value={opcion.texto}
              handleChange={(content) => onUpdate({ texto: content })}
              placeholder="Texto de la opción"
              allowImages={false}
            />
          </div>
          
          <div className="col-auto" style={{width: '120px'}}>
            <div className="input-group input-group-sm">
              <span className="input-group-text" style={{backgroundColor: '#fff7e6', borderColor: '#ffc107'}}>
                <span style={{color: '#ffc107', fontSize: '14px'}}>★</span>
              </span>
              <input
                type="number"
                className="form-control"
                value={puntajeInput}
                disabled={lockPuntaje}
                onChange={(e) => {
                  if (lockPuntaje) {
                    return;
                  }
                  setPuntajeInput(e.target.value);
                  const valor = parseFloat(e.target.value);
                  if (!isNaN(valor) && valor >= 0) {
                    const updates = { puntaje: valor };
                    if (autoDesactivarConPuntajeCero && valor === 0 && opcion.esCorrecta) {
                      updates.esCorrecta = false;
                    }
                    onUpdate(updates);
                  }
                }}
                onBlur={() => {
                  if (lockPuntaje) {
                    return;
                  }
                  const valor = parseFloat(puntajeInput);
                  if (isNaN(valor) || valor < 0) {
                    setPuntajeInput('0');
                    const updates = { puntaje: 0 };
                    if (autoDesactivarConPuntajeCero && opcion.esCorrecta) {
                      updates.esCorrecta = false;
                    }
                    onUpdate(updates);
                  } else {
                    setPuntajeInput(String(valor));
                    if (autoDesactivarConPuntajeCero && valor === 0 && opcion.esCorrecta) {
                      onUpdate({ puntaje: valor, esCorrecta: false });
                    }
                  }
                }}
                onFocus={(e) => e.target.select()}
                placeholder="Puntos"
                min="0"
                step="0.5"
              />
            </div>
          </div>
          
          <div className="col-auto">
            <span className={`badge ${esCorrectaVisible ? 'badge-correcta' : 'badge-incorrecta'}`}>
              {esCorrectaVisible ? (
                <>
                  <i className="fas fa-check me-1"></i>
                  Es correcta
                </>
              ) : (
                <>
                  <i className="fas fa-times me-1"></i>
                  Es incorrecta
                </>
              )}
            </span>
          </div>
          
          <div className="col-auto">
            <button
              type="button"
              className="btn btn-sm"
              style={{
                backgroundColor: canDelete ? '#e74c3c' : '#ccc',
                border: 'none',
                color: 'white',
                fontWeight: 500,
                cursor: canDelete ? 'pointer' : 'not-allowed',
                opacity: canDelete ? 1 : 0.6
              }}
              onClick={canDelete ? onEliminar : undefined}
              title={canDelete ? 'Eliminar opción' : 'Mínimo 2 opciones requeridas'}
              disabled={!canDelete}
            >
              <i className="fas fa-trash me-1"></i>
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpcionItem;
